import { InvoiceShort } from "../models/invoice/invoice-short";

export const inProcessingRecord: InvoiceShort = {
    id: null,
    date: null,
    amountDue: null,
    supplierName: "Processing",
    invoiceNumber: "Extracting Details ...",
    categories: [],
    shortCode:"",
    rowCount:0,
    contactStatus:"",
    accountName:"",
    isProcessed: false,
    invoiceLines:[],
    accountId: "",
    checked: false,
    invoicePdfUrl: "",
    tags: [],
    hexColorClass: "",
    createdAt: null,
    type: "",
    dueDate: null,
    subtotal: 0,
    totalTax: 0,
    visible: false,
    required_Fields: false,
    submitterName: "",
    isMatched: false
};